import { render, staticRenderFns } from "./Ppom_Navbar.vue?vue&type=template&id=01de3bac&scoped=true"
import script from "./Ppom_Navbar.vue?vue&type=script&lang=js"
export * from "./Ppom_Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de3bac",
  null
  
)

export default component.exports